module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-holder performance"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "slidein touch-scroll"
  }, [_c('div', {
    staticClass: "data-content content"
  }, [(_vm.item && _vm.item.id && !_vm.loading) ? _c('div', {
    staticClass: "rotator-controls"
  }, [_c('div', {
    staticClass: "new-rotator-select-container"
  }, [_c('h1', {
    staticClass: "headerone__default"
  }, [_c('span', {
    staticClass: "bold__optional"
  }, [_vm._v("Affiliate")]), _vm._v(" "), (!_vm.configured && _vm.$store.getters.isEmployee && !_vm.$store.state.user.affiliate_id) ? _c('el-select', {
    staticClass: "rotator-affiliate",
    attrs: {
      "size": "small",
      "placeholder": "Select Affiliate",
      "popper-class": "affiliate-select",
      "filterable": "",
      "remote": "",
      "remote-method": _vm.searchAffiliates,
      "no-match-text": "No Matches",
      "loading": _vm.affLoading,
      "loading-text": "Loading..."
    },
    on: {
      "focus": function($event) {
        _vm.searchAffiliates('')
      }
    },
    nativeOn: {
      "keydown": function($event) {
        _vm.selectAffiliate($event)
      }
    },
    model: {
      value: (_vm.data.affiliate_id),
      callback: function($$v) {
        _vm.$set(_vm.data, "affiliate_id", $$v)
      },
      expression: "data.affiliate_id"
    }
  }, _vm._l((_vm.$store.state.cache.affiliateList), function(affiliate) {
    return _c('el-option', {
      key: affiliate.affiliate_id,
      attrs: {
        "v-if": affiliate.affiliate_id != 0,
        "value": affiliate.affiliate_id,
        "label": affiliate.affiliate_id
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(affiliate.label))]), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(affiliate.affiliate_id))])])
  })) : _c('span', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.data.affiliate_id))])], 1), _vm._v(" "), _c('h1', {
    staticClass: "headerone__default"
  }, [_c('span', {
    staticClass: "bold__optional"
  }, [_vm._v("Vertical")]), _vm._v(" "), (!_vm.configured) ? _c('el-select', {
    staticClass: "new-rotator__selector",
    attrs: {
      "placeholder": "Select Vertical",
      "size": "small",
      "filterable": ""
    },
    model: {
      value: (_vm.data.vertical),
      callback: function($$v) {
        _vm.$set(_vm.data, "vertical", $$v)
      },
      expression: "data.vertical"
    }
  }, _vm._l((_vm.$store.state.cache.vertList), function(vert) {
    return _c('el-option', {
      key: vert.id,
      attrs: {
        "value": vert.name,
        "label": vert.name
      }
    })
  })) : _c('span', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.data.vertical))])], 1), _vm._v(" "), _c('h1', {
    staticClass: "headerone__default"
  }, [_c('span', {
    staticClass: "bold__optional"
  }, [_vm._v("Geo")]), _vm._v(" "), (!_vm.configured) ? _c('el-select', {
    staticClass: "new-rotator__selector",
    attrs: {
      "placeholder": "Select Country",
      "size": "small",
      "popper-class": "affiliate-select",
      "filterable": ""
    },
    model: {
      value: (_vm.data.country),
      callback: function($$v) {
        _vm.$set(_vm.data, "country", $$v)
      },
      expression: "data.country"
    }
  }, _vm._l((_vm.$store.state.cache.geoList), function(geo) {
    return _c('el-option', {
      key: geo.id,
      attrs: {
        "value": geo.code,
        "label": geo.name
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(geo.name))]), _vm._v(" "), _c('span', {
      staticClass: "value"
    }, [_vm._v(_vm._s(geo.code))])])
  })) : _c('span', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.countryName))])], 1), _vm._v(" "), _c('div', {
    staticClass: "launch-rotator-button-holder"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.isNew) ? _c('el-button', {
    staticClass: "btn__default launch-radius-button hidden-sm-and-down",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.radiusSetup(_vm.item.id)
      }
    }
  }, [_vm._v("\n                  Bridge Page Setup\n              ")]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.configured) ? _c('el-button', {
    staticClass: "btn__default save-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.nextStepAdd
    }
  }, [_vm._v("Continue")]) : _c('div', {
    staticClass: "rotator-controls-info"
  }, [_c('el-collapse', {
    ref: "rotator-collapse",
    model: {
      value: (_vm.activeTabs),
      callback: function($$v) {
        _vm.activeTabs = $$v
      },
      expression: "activeTabs"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "Tracking Links",
      "name": "1"
    }
  }, _vm._l((_vm.data.tracking_links), function(link, step, index) {
    return _c('div', {
      key: step,
      staticClass: "tracking-link-container__default clearfix"
    }, [_c('h2', {
      staticClass: "headertwo__default header__column"
    }, [_vm._v(_vm._s(step.charAt(0).toUpperCase() + step.slice(1)))]), _vm._v(" "), _c('div', {
      staticClass: "tracking-links__column"
    }, [_c('h2', {
      staticClass: "headertwo__default"
    }, [_vm._v("Rotator Tracking Link:")]), _vm._v(" "), _c('div', {
      staticClass: "tracklink-static"
    }, [_vm._v(_vm._s(_vm.JBTrackingLinkBase) + "&step=" + _vm._s(step.slice(4)))]), _vm._v(" "), _c('el-button', {
      staticClass: "copy-btn__default",
      class: {
        copied: _vm.copied[index * 2]
      },
      attrs: {
        "type": "info",
        "size": "mini",
        "plain": ""
      },
      on: {
        "click": function($event) {
          _vm.copyToClipboard(index * 2)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.copied[index * 2] ? 'Copied !' : 'Copy to Clipboard') + "\n                    ")]), _vm._v(" "), _c('textarea', {
      ref: "copyTextarea",
      refInFor: true,
      staticClass: "hide-textarea",
      attrs: {
        "id": "code-top-copy"
      }
    }, [_vm._v(_vm._s(_vm.JBTrackingLinkBase) + "&step=" + _vm._s(step.slice(4)))]), _vm._v(" "), _c('h2', {
      staticClass: "headertwo__default"
    }, [_vm._v("3rd Party Tracking Link (Optional):")]), _vm._v(" "), _c('el-input', {
      ref: 'tracking-link-' + step,
      refInFor: true,
      attrs: {
        "placeholder": 'https://your-' + step + '-tracking-link.com/click/'
      },
      model: {
        value: (_vm.data.tracking_links[step]),
        callback: function($$v) {
          _vm.$set(_vm.data.tracking_links, step, $$v)
        },
        expression: "data.tracking_links[step]"
      }
    }), _vm._v(" "), _c('el-button', {
      staticClass: "copy-btn__default",
      class: {
        copied: _vm.copied[index * 2 + 1]
      },
      attrs: {
        "type": "info",
        "size": "mini",
        "plain": ""
      },
      on: {
        "click": function($event) {
          _vm.copyToClipboard(index * 2 + 1)
        }
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.copied[index * 2 + 1] ? 'Copied !' : 'Copy to Clipboard') + "\n                    ")]), _vm._v(" "), _c('textarea', {
      ref: "copyTextarea",
      refInFor: true,
      staticClass: "hide-textarea",
      attrs: {
        "id": "code-top-copy"
      }
    }, [_vm._v(_vm._s(_vm.data.tracking_links[step] || ' '))]), _vm._v(" "), _c('div', {
      staticClass: "tracking-link__macro add-macro"
    }, [_c('span', {
      staticClass: "macro__title"
    }, [_vm._v("Macros: ")]), _vm._v(" "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          _vm.data.tracking_links[step] = _vm.addMacro('tracking-link-' + step, 0, 'xxbpsxx')
        }
      }
    }, [_vm._v("Session ID")]), _vm._v(" |\n                      "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          _vm.data.tracking_links[step] = _vm.addMacro('tracking-link-' + step, 0, 'xxprogidxx')
        }
      }
    }, [_vm._v("Campaign ID")]), _vm._v(" |\n                      "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          _vm.data.tracking_links[step] = _vm.addMacro('tracking-link-' + step, 0, 'xxagentidxx')
        }
      }
    }, [_vm._v("Affiliate ID")]), _vm._v(" |\n                      "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          _vm.addMacroPrompt(step, 'Name of the Query String parameter you want to pass:', 'yy')
        }
      }
    }, [_vm._v("Query String Parameter")]), _vm._v(" |\n                      "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          _vm.addMacroPrompt(step, 'Name of the Javascript variable you want to pass:', 'zz')
        }
      }
    }, [_vm._v("Javascript Variable")])])], 1)])
  })), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n                  Campaigns\n                  "), _c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.collapseItemAdd('2', _vm.addCampaign)
      }
    }
  }, [_vm._v("Add  "), _c('i', {
    staticClass: "el-icon-circle-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "campaign-collection"
  }, [_c('draggable', {
    staticClass: "block__default",
    attrs: {
      "list": _vm.data.campaigns,
      "options": {
        disabled: _vm.$isTouch
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition,
      "duration": _vm.$isTouch ? 600 : 400,
      "tag": "div"
    }
  }, _vm._l((_vm.data.campaigns), function(campaign, index) {
    return _c('el-card', {
      key: campaign.rand,
      staticClass: "box-card row__default",
      class: [{
        'inactive': !_vm.isInRotation(campaign),
        'employee-active': _vm.$store.getters.isEmployee
      }]
    }, [_c('ul', {
      staticClass: "box-card-inner has-index"
    }, [_c('ul', {
      staticClass: "order-set order-change"
    }, [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > 0),
        expression: "index > 0"
      }],
      staticClass: "arrow arrow-up",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.orderChange(_vm.data.campaigns, index, -1)
        }
      }
    }), _vm._v(" "), _c('li', {
      staticClass: "order-badge__default"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != _vm.data.campaigns.length - 1),
        expression: "index != data.campaigns.length - 1"
      }],
      staticClass: "arrow arrow-down",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.orderChange(_vm.data.campaigns, index, 1)
        }
      }
    })]), _vm._v(" "), _c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Campaign:")]), _vm._v(" "), _c('el-select', {
      staticClass: "input__default select__default",
      attrs: {
        "filterable": "",
        "value-key": "step1_campaign_id",
        "filter-method": function (q) { return (function () {
          _vm.searchCampaigns(campaign, q)
        })(); },
        "no-data-text": "No Matches",
        "popper-class": "sidebar-select"
      },
      on: {
        "change": function (item) { return (function () {
          _vm.setCampaign(index, item)
        })(); },
        "focus": function($event) {
          _vm.searchCampaigns(campaign, ''), _vm.getCampaignList()
        }
      },
      model: {
        value: (campaign.name),
        callback: function($$v) {
          _vm.$set(campaign, "name", $$v)
        },
        expression: "campaign.name"
      }
    }, _vm._l((_vm.getCampaignOptions(campaign)), function(item) {
      return _c('el-option', {
        key: item.step1_campaign_id,
        attrs: {
          "label": item.step1_campaign_name,
          "value": item
        }
      }, [_c('span', {
        staticClass: "label"
      }, [_vm._v(_vm._s(item.step1_campaign_name))]), _vm._v(" "), _c('span', {
        staticClass: "value"
      }, [_vm._v(_vm._s(item.step1_campaign_id))])])
    }))], 1), _vm._v(" "), _c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Status:")]), _vm._v(" "), _c('el-select', {
      staticClass: "input__default select__default",
      model: {
        value: (campaign.status),
        callback: function($$v) {
          _vm.$set(campaign, "status", $$v)
        },
        expression: "campaign.status"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "Enabled",
        "value": "active"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Disabled",
        "value": "inactive"
      }
    })], 1)], 1), _vm._v(" "), _c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Weight:")]), _vm._v(" "), _c('el-input', {
      staticClass: "input__default",
      attrs: {
        "disabled": _vm.hasWeightedWeightStrategy ? false : true
      },
      model: {
        value: (campaign.weight),
        callback: function($$v) {
          _vm.$set(campaign, "weight", $$v)
        },
        expression: "campaign.weight"
      }
    })], 1), _vm._v(" "), (_vm.$store.getters.isEmployee) ? _c('ul', {
      staticClass: "exclusive__employee"
    }, [_c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Weekly Cap:")]), _vm._v(" "), _c('el-input', {
      staticClass: "input__default",
      model: {
        value: (campaign.weekly_cap),
        callback: function($$v) {
          _vm.$set(campaign, "weekly_cap", $$v)
        },
        expression: "campaign.weekly_cap"
      }
    })], 1), _vm._v(" "), _c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Daily Cap:")]), _vm._v(" "), _c('el-input', {
      staticClass: "input__default",
      model: {
        value: (campaign.daily_cap),
        callback: function($$v) {
          _vm.$set(campaign, "daily_cap", $$v)
        },
        expression: "campaign.daily_cap"
      }
    })], 1), _vm._v(" "), _c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Redirect:")]), _vm._v(" "), _c('el-input', {
      staticClass: "input__default",
      model: {
        value: (campaign.redirect_campaign_id),
        callback: function($$v) {
          _vm.$set(campaign, "redirect_campaign_id", $$v)
        },
        expression: "campaign.redirect_campaign_id"
      }
    })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "tools-collection__default",
      class: (campaign.state && campaign.state.toLowerCase()) || 'default'
    }, [(campaign.state) ? _c('p', {
      staticClass: "status-content"
    }, [_vm._v("Campaign " + _vm._s(campaign.state)), (!_vm.isInRotation(campaign)) ? _c('span', [_vm._v(" - Not In Rotation")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.data.campaigns && _vm.data.campaigns.length > 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-delete"
      },
      on: {
        "click": function($event) {
          _vm.remove(_vm.data.campaigns, campaign)
        }
      }
    }) : _vm._e()], 1)])
  }))], 1)], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "3"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "hidden-md-and-down"
  }, [_vm._v("Rotation ")]), _vm._v("Strategies\n                  "), _c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.collapseItemAdd('3', _vm.addNonMlStrategy)
      }
    }
  }, [_vm._v("Add  "), _c('i', {
    staticClass: "el-icon-circle-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "campaign-collection block__default"
  }, [_c('draggable', {
    attrs: {
      "list": _vm.data.strategies,
      "options": {
        disabled: _vm.$isTouch
      }
    }
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition,
      "duration": _vm.$isTouch ? 600 : 400
    }
  }, _vm._l((_vm.data.strategies), function(strategy, index) {
    return (strategy.strategy != 'ml') ? _c('el-card', {
      key: strategy.rand,
      staticClass: "box-card row__default"
    }, [_c('ul', {
      staticClass: "box-card-inner has-index"
    }, [_c('ul', {
      staticClass: "order-set order-change"
    }, [_c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index > (_vm.data.strategies.indexOf(_vm.mlStrategy) + 1)),
        expression: "index > (data.strategies.indexOf(mlStrategy) + 1)"
      }],
      staticClass: "arrow arrow-up",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.orderChange(_vm.data.strategies, index, -1)
        }
      }
    }), _vm._v(" "), _c('li', {
      staticClass: "order-badge__default"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index < _vm.data.strategies.length - 1),
        expression: "index < data.strategies.length - 1"
      }],
      staticClass: "arrow arrow-down",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.orderChange(_vm.data.strategies, index, 1)
        }
      }
    })]), _vm._v(" "), _c('li', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Strategy:")]), _vm._v(" "), _c('el-select', {
      staticClass: "input__default select__default",
      attrs: {
        "placeholder": "Select Strategy"
      },
      on: {
        "change": function($event) {
          _vm.resetStrategy(index)
        }
      },
      model: {
        value: (strategy.strategy),
        callback: function($$v) {
          _vm.$set(strategy, "strategy", $$v)
        },
        expression: "strategy.strategy"
      }
    }, [_c('el-option', {
      attrs: {
        "value": "threshold",
        "label": "Blended EPC"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "maximize",
        "label": "Maximum EPC"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "minimize",
        "label": "Ordered"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "weighted",
        "label": "Weighted"
      }
    })], 1)], 1), _vm._v(" "), (strategy.strategy === 'threshold') ? _c('li', [_c('div', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Required $ EPC:")]), _vm._v(" "), _c('el-input', {
      staticClass: "input__default",
      attrs: {
        "name": "threshold",
        "type": "number"
      },
      model: {
        value: (strategy.threshold),
        callback: function($$v) {
          _vm.$set(strategy, "threshold", $$v)
        },
        expression: "strategy.threshold"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), (strategy.strategy === 'weighted') ? _c('li', [_c('div', {
      staticClass: "column__default"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Metric:")]), _vm._v(" "), _c('el-select', {
      staticClass: "input__default",
      attrs: {
        "placeholder": "Select Metric"
      },
      model: {
        value: (strategy.optimal_metric),
        callback: function($$v) {
          _vm.$set(strategy, "optimal_metric", $$v)
        },
        expression: "strategy.optimal_metric"
      }
    }, [_c('el-option', {
      attrs: {
        "value": "weight",
        "label": "Weight"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "conversion_rate",
        "label": "Conv Rate"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "daily_cap",
        "label": "Remaining Daily CAP"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "weekly_cap",
        "label": "Remaining Weekly CAP"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "total_daily_cap",
        "label": "Total Daily CAP"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "total_weekly_cap",
        "label": "Total Weekly CAP"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "epc_out",
        "label": "EPC Out"
      }
    })], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "tools-collection__default"
    }, [(_vm.nonMlStrategies.length > 1) ? _c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-delete"
      },
      on: {
        "click": function($event) {
          _vm.remove(_vm.data.strategies, strategy)
        }
      }
    }) : _vm._e()], 1)]) : _vm._e()
  }))], 1)], 1)], 2), _vm._v(" "), _c('el-collapse-item', {
    attrs: {
      "name": "4"
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("\n                  Pixels\n                  "), _c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.collapseItemAdd('4', _vm.addPixel)
      }
    }
  }, [_vm._v("Add  "), _c('i', {
    staticClass: "el-icon-circle-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "campaign-collection block__default"
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition,
      "duration": _vm.$isTouch ? 600 : 400
    }
  }, [(!_vm.data.pixels || _vm.data.pixels.length == 0) ? _c('div', {
    key: "no-data",
    staticClass: "row__default non-draggable__default"
  }, [_c('div', {
    staticClass: "box-card-inner pixel"
  }, [_vm._v("\n                        There are no pixels attached to this rotator.\n                      ")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.data.pixels), function(pixel, index) {
    return _c('el-card', {
      key: pixel.rand,
      staticClass: "box-card row__default"
    }, [_c('ul', {
      staticClass: "box-card-inner pixel-container"
    }, [_c('li', {
      staticClass: "column__default column__default__short"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Type:")]), _vm._v(" "), _c('el-select', {
      staticClass: "input__default select__default",
      model: {
        value: (pixel.type),
        callback: function($$v) {
          _vm.$set(pixel, "type", $$v)
        },
        expression: "pixel.type"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "HTML/JS",
        "value": "html"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Postback",
        "value": "postback"
      }
    }, [_vm._v("Postback")])], 1)], 1), _vm._v(" "), (pixel.type != '') ? _c('li', {
      staticClass: "column__default column__default__wide"
    }, [_c('p', {
      staticClass: "label__default"
    }, [_vm._v("Code:")]), _vm._v(" "), (pixel.type == 'html') ? _c('el-input', {
      ref: "pixel",
      refInFor: true,
      staticClass: "input__default",
      attrs: {
        "type": "textarea",
        "placeholder": "<iframe src=\"https://your-pixel-url.com?sid=xxsidxx\"></iframe>"
      },
      model: {
        value: (pixel.code),
        callback: function($$v) {
          _vm.$set(pixel, "code", $$v)
        },
        expression: "pixel.code"
      }
    }) : _c('el-input', {
      ref: "pixel",
      refInFor: true,
      staticClass: "input__default",
      attrs: {
        "placeholder": "https://your-pixel-url.com?sid=xxsidxx"
      },
      model: {
        value: (pixel.code),
        callback: function($$v) {
          _vm.$set(pixel, "code", $$v)
        },
        expression: "pixel.code"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "tracking-link__macro add-macro"
    }, [_c('span', {
      staticClass: "macro__title"
    }, [_vm._v("Macros: ")]), _vm._v(" "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          pixel.code = _vm.addMacro('pixel', index, 'xxprogidxx')
        }
      }
    }, [_vm._v("Campaign ID")]), _vm._v(" |\n                            "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          pixel.code = _vm.addMacro('pixel', index, 'xxagentidxx')
        }
      }
    }, [_vm._v("Affiliate ID")]), _vm._v(" |\n                            "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          pixel.code = _vm.addMacro('pixel', index, 'xxhitidxx')
        }
      }
    }, [_vm._v("Hit ID")]), _vm._v(" |\n                            "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          pixel.code = _vm.addMacro('pixel', index, 'xxc1xx')
        }
      }
    }, [_vm._v("C1")]), _vm._v(" |\n                            "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          pixel.code = _vm.addMacro('pixel', index, 'xxc2xx')
        }
      }
    }, [_vm._v("C2")]), _vm._v(" |\n                            "), _c('a', {
      staticClass: "macro__link",
      on: {
        "click": function($event) {
          pixel.code = _vm.addMacro('pixel', index, 'xxc3xx')
        }
      }
    }, [_vm._v("C3")])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "tools-collection__default"
    }, [_c('el-button', {
      attrs: {
        "type": "primary",
        "icon": "el-icon-delete"
      },
      on: {
        "click": function($event) {
          _vm.remove(_vm.data.pixels, pixel)
        }
      }
    })], 1)])
  })], 2)], 1)], 2)], 1), _vm._v(" "), _c('el-button', {
    staticClass: "btn__default save-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [(!_vm.saveLoading) ? [_vm._v("\n                " + _vm._s(_vm.isNew ? 'Add New Rotator' : 'Save Changes') + "\n              ")] : _c('div', {
    staticClass: "el-loading-spinner save-btn-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])], 2)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.message) ? _c('p', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])]), _vm._v(" "), (typeof(_vm.item) == 'string' || _vm.loading) ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "campaign-loader"
  }, [_c('div', {
    staticClass: "el-loading-spinner"
  }, [_c('svg', {
    staticClass: "circular",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "fill": "none"
    }
  })])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "data-holder-inner"
  }, [_c('div', {
    staticClass: "filter-holder row"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c017d3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/rotator.vue
// module id = hN6x
// module chunks = 1